import {
  ComponentPropsWithoutRef,
  FC,
  ReactElement,
  cloneElement,
} from "react";
import Typography from "./Typography";

type InfoTileProps = {
  title?: string;
  description: string | ReactElement;
  icon?: ReactElement<HTMLDivElement>;
  size?: "s" | "m" | "l";
  trailing?: ReactElement;
} & ComponentPropsWithoutRef<"div">;

const InfoTile: FC<InfoTileProps> = ({
  title,
  description,
  icon,
  size = "m",
  trailing,
  ...rest
}) => {
  const sizeClasses = {
    s: "px-3 py-2",
    m: "px-6 py-4",
    l: "px-8 py-5",
  };
  return (
    <div
      {...rest}
      className={`${rest.className} ${sizeClasses[size]} bg-slate-150 rounded-xl text-slate-700 flex items-center gap-2`}
    >
      {icon ? (
        cloneElement(icon, {
          className: `${icon.props.className} w-4 h-4 shrink-0`,
        })
      ) : (
        <></>
      )}

      <div>
        {title && (
          <Typography variant="subtitle2" className="mb-1 block">
            {title}
          </Typography>
        )}
        <Typography variant="caption">{description}</Typography>
      </div>
      {trailing && trailing}
    </div>
  );
};

export default InfoTile;
